import { AttachSlotToInvitationBody } from '@omecare/utils';
import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import http from '@/utils/http.service';
import { pendingInvitationsByOfficeQueryKey } from '../queries/use-get-pending-invitations-by-office';

export type AttachSlotToInvitationPayload = AttachSlotToInvitationBody & {
  invitationId: string;
};

const attachSlotToInvitation = ({
  invitationId,
  slotId,
  officeId,
}: AttachSlotToInvitationPayload) => {
  return http.invitations.attachSlot(invitationId, { slotId, officeId });
};

const useAttachSlotToInvitation = (): UseMutationResult<
  { success: boolean },
  Error,
  AttachSlotToInvitationPayload
> => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: attachSlotToInvitation,
    onSuccess(_data, variables) {
      queryClient.invalidateQueries({ queryKey: ['office-agenda-slots'] });
      queryClient.invalidateQueries({
        queryKey: pendingInvitationsByOfficeQueryKey(variables.officeId),
      });
      toast.success(t('http.attach-slot-to-invitation.success'));
    },
  });
};

export default useAttachSlotToInvitation;
